import type { Asset } from '../../../../api/assetAdministrationBackendCodec.ts';
import { useState } from 'react';
import { useAppDispatch } from '../../../../../configuration/setup/hooks.ts';
import { useIntl } from 'react-intl';
import { useActivateAssetMutation } from '../../../../../services/assetsApi.ts';
import { sleep } from '../../../../../utils.ts';
import { assetModified } from '../assetSidebarSlice.ts';
import Notification from '@rio-cloud/rio-uikit/Notification';
import { AssetActivationDialog } from '../../dialogs/AssetActivationDialog.tsx';

export const ActivateAsset = ({ asset }: { asset: Asset }) => {
    const [showDialog, setShowDialog] = useState(false);
    const dispatch = useAppDispatch();
    const intl = useIntl();
    const [activateAsset] = useActivateAssetMutation();

    const handleActivate = (assetId: string, reason: string) => {
        activateAsset({ assetId, reason })
            .unwrap()
            .then(() => sleep(1000))
            .then(() => dispatch(assetModified()))
            .catch(error => {
                console.error(`Could not activate asset: ${error}`);
                Notification.error(intl.formatMessage({ id: 'assets-helpgang.notification.couldNotActivateAsset' }));
            });
        setShowDialog(false);
    };

    return (
        <>
            <button
                type={'button'}
                className={'btn btn-info'}
                onClick={() => {
                    setShowDialog(true);
                }}
                data-cy='activate-asset-button'
            >
                <span className={'uikit-icon icon-inbox-out'} />
                Activate
            </button>
            <AssetActivationDialog
                showActivationDialog={showDialog}
                setShowActivationDialog={setShowDialog}
                asset={{
                    id: asset.id,
                    vin: asset.identification,
                    accountId: asset.account_id,
                    status: asset.status,
                }}
                handleActivateConfirm={handleActivate}
            />
        </>
    );
};
